<app-estudio-medico-form
  [estudioMedico]="estudioMedico"
  [editar]="editar"
></app-estudio-medico-form>

<app-odontograma-config *ngIf="esOdontograma"></app-odontograma-config>
<app-periodontograma-config *ngIf="esPeriodontograma"></app-periodontograma-config>
